import React from 'react';
import {observer} from 'mobx-react';
import {Route, Switch} from 'react-router-dom';
import DetailView from "../media/DetailView";
import TagMediaView from "../media/TagMediaView";
import {tagMediaStore} from "../../store/MediaStore";
import axios from "axios";
import CommonHelper from "../../helper/CommonHelper";
import qs from "qs";
import {toJS} from "mobx";

const store = tagMediaStore;

@observer
class TagMediaViewFrame extends React.Component {

    componentDidMount() {
        let {match:{params:{tagId, type}}, location} = this.props;
        this.load(tagId);

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let {match:{params:{tagId}}} = this.props;
        if(tagId !== prevProps.match.params.tagId){
            store.searchCondition.clear();
            this.load(tagId)
        }
    }

    load(tagId){
        axios.post(`/tag/detail/${tagId}`,{})
            .then(({data})=>{
                let tagId = data?.id;
                store.target = data;
                store.searchCondition.replace(CommonHelper.objectToMap({...qs.parse(this.props.location.search, { ignoreQueryPrefix: true }), tagId}));
                store.debounceFetch(true);
            })
    }

    render() {
        return (
            <Switch>
                <Route path="/main/tag/:type/:tagId/:folderId/:fileId" component={DetailView}/>
                <Route path="/main/tag/:type/:tagId" component={TagMediaView}/>
            </Switch>
        );

    }
}

export default TagMediaViewFrame;
